<template>
	<db-row height="auto" class="cuttle-wrapper">
		<db-col height="auto" class="cuttle-header" @click="open">
			{{title}}
			<slot name="cuttle-header" />
			<db-col class="auto-fill" align="right">
				<db-icon :icon="show ? 'arr-up' : 'arr-down'" color="#999" />
			</db-col>
		</db-col>
		<db-row class="ovh cuttle-container" :id="id" :style="style"><slot></slot></db-row>
	</db-row>
</template>

<script>
	export default {
		name: 'cuttle',
		
		props: {
			title: {
				type: String,
				default: ''
			},
			
			init: {
				type: Boolean,
				default: false
			}
		},
		
		inject: ['refresh'],
		
		data(){
			return {
				style: {
					height: '0',
				},
				realHeight: 0,
				id: 'cuttle_' + Math.random(),
				show: this.init
			}
		},
		
		watch: {
			show(val){
				if(val){
					this.style.height = this.realHeight + 'px'
				}else{
					this.style.height = '0px'
				}
				this.$nextTick(() => {
					this.refresh && this.refresh()
				})
			}
		},
		
		mounted(){
			setTimeout(() => {
				const dom = document.getElementById(this.id)
				this.realHeight = dom.scrollHeight
				if(this.show){
					this.style.height = this.realHeight + 'px'
				}
			}, 1000)
		},
		
		methods: {
			open(){
				this.show = !this.show
				setTimeout(() => {
					this.refresh && this.refresh()
				}, 300)
			}
		}
	}
</script>

<style lang="scss" type="text/scss">
	.cuttle-wrapper{
		.cuttle-header{
			color: #333;
			font-size: 28px;
			font-weight: bold;
			padding: 24px 0;
		}
	}
	
	
	
	.cuttle-container{
		transition: height .2s;
	}
</style>
